module.exports = __webpack_public_path__ + "static/media/home-header.5ddc08d2.png";